import React from 'react';

export const viewportToolRailRenderPropsEqual = (previous, next) => {
  if (previous.revision !== next.revision) return false;
  const previousDependencies = previous.externalDependencies || [];
  const nextDependencies = next.externalDependencies || [];
  return previousDependencies.length === nextDependencies.length
    && previousDependencies.every((dependency, index) => Object.is(dependency, nextDependencies[index]));
};

export const ViewportToolRailRenderBoundary = React.memo(
  ({ children }) => children,
  viewportToolRailRenderPropsEqual,
);
ViewportToolRailRenderBoundary.displayName = 'ViewportToolRailRenderBoundary';
